import React from 'react'
import './Dashboard.scss'
import { EmpAnouncement, EmpEvent, EmpProfile, EmpResources } from 'Pages/Frontend/Components'
import { ExitForm } from '../../ExitForm/ExitForm'
import { useEmployeeProfile } from 'Context/ProfileContext'

const Dashboard = () => {
  const { profile } = useEmployeeProfile()

  const isExitedUser = ['ON_OFFBOARDING', 'COMPLETED_OFFBOARDING', 'TERMINATED'].includes(
    profile?.employmentStatus || '',
  )

  return (
    <div className='Dashboard me-3 ms-3 me-md-3 ms-md-2'>
      {isExitedUser ? (
        <div>
          <ExitForm />
        </div>
      ) : (
        <div className='container'>
          <div className='welcome-message'>Welcome to your TradeGrid Employee Dashboard! 👋</div>

          <div className='row'>
            <div className='col-md-8 d-none'>
              <EmpProfile></EmpProfile>
            </div>
            <div className='col-md-6'>
              <EmpAnouncement></EmpAnouncement>
            </div>

            <div className='col-md-8 d-none'>
              <EmpResources></EmpResources>
            </div>

            <div className='col-md-6'>
              <EmpEvent></EmpEvent>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Dashboard
